<script lang="ts">
  import Avatar from './Avatar.svelte';
  import * as Popover from '$lib/components/ui/popover';

  type Reader = {
    id: number;
    first_name: string;
    last_name: string;
    username: string;
    profile_photo?: string;
  };

  // Readers already resolved by the caller to "this is the most recent message this
  // person has read" -- this component just renders them, it doesn't do that dedup.
  export let readers: Reader[] = [];
</script>

{#if readers.length > 0}
  <div class="flex items-center" style="--avatar-height: 1em;">
    {#each readers as reader, i (reader.id)}
      <Popover.Root portal="#shadcn-ui-dialog-target">
        <Popover.Trigger asChild let:builder>
          <button
            use:builder.action
            {...builder}
            type="button"
            class="inline-block rounded-full ring-1 ring-background p-0 border-0 bg-transparent leading-none cursor-pointer"
            style={i > 0 ? 'margin-left: -0.35em;' : ''}
          >
            <Avatar
              profile_photo={reader.profile_photo}
              first_name={reader.first_name}
              last_name={reader.last_name}
              username={reader.username}
              shape="circle"
              pad_right={false}
            />
          </button>
        </Popover.Trigger>
        <Popover.Content class="w-fit px-2 py-1 text-xs" side="top">
          Read by {reader.first_name} {reader.last_name}
        </Popover.Content>
      </Popover.Root>
    {/each}
  </div>
{/if}
